class ParticleSystem extends HTMLElement {
  constructor() {
    super();
  }

  generateDot() {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    const clientWidth = this.clientWidth;
    const clientHeight = this.clientHeight;

    const contentHeight = 0; // optional, for layout offset
    const MARGIN_SPACING = 32;
    const mobileReduceHeight = isMobile ? contentHeight + MARGIN_SPACING : 0;
    const sceneWidth = clientWidth - mobileReduceHeight;
    const sceneHeight = clientHeight - mobileReduceHeight;

    const getRandomArbitrary = (min, max) =>
      (Math.random() * (max - min) + min).toFixed(3);

    const widthBefore = (x, y, rotate) => {
      let angleToTopLeftCorner = (Math.atan(y / x) * 180) / Math.PI;
      let width = 0;
      if (rotate < angleToTopLeftCorner) {
        let a1 = Math.tan((rotate * Math.PI) / 180) * x;
        width = Math.sqrt(a1 * a1 + x * x);
      } else {
        let a1 = Math.tan(((90 - rotate) * Math.PI) / 180) * y;
        width = Math.sqrt(a1 * a1 + y * y);
      }
      return width;
    };

    const widthAfter = (x, y, rotate, screenWidth, sceneHeight) => {
      let angleToBottomRightCorner =
        (Math.atan((sceneHeight - y) / (screenWidth - x)) * 180) / Math.PI;
      let width = 0;
      if (rotate < angleToBottomRightCorner) {
        let x1 = screenWidth - x;
        let a1 = Math.tan((rotate * Math.PI) / 180) * x1;
        width = Math.sqrt(a1 * a1 + x1 * x1);
      } else {
        let y1 = sceneHeight - y;
        let a1 = Math.tan(((90 - rotate) * Math.PI) / 180) * y1;
        width = Math.sqrt(a1 * a1 + y1 * y1);
      }
      return width;
    };

    const x = ((getRandomArbitrary(0, 100) / 100) * sceneWidth).toFixed(3);
    const y = ((getRandomArbitrary(0, 100) / 100) * sceneHeight).toFixed(3);
    const rotate = getRandomArbitrary(0, 90);
    const size = isMobile ? getRandomArbitrary(2, 6) : getRandomArbitrary(1, 15);
    const width_before = widthBefore(x, y, +rotate) + "px";
    const width_after = widthAfter(x, y, +rotate, sceneWidth, sceneHeight) + "px";
    const speed = getRandomArbitrary(10, 15) + "s";
    const direction = Math.random().toFixed(3) > 0.49 ? "normal" : "reverse";
    const start_time = getRandomArbitrary(6, 12) + "s";
    const scale = getRandomArbitrary(10, 20) + "s";
    const z_position = getRandomArbitrary(1.5, 4);

    const wrapper = document.createElement("div");
    wrapper.className = "position";

    wrapper.style.setProperty("--x", x);
    wrapper.style.setProperty("--y", y);
    wrapper.style.setProperty("--rotate", rotate + 'deg');
    wrapper.style.setProperty("--size", size);
    wrapper.style.setProperty("--widthBefore", width_before);
    wrapper.style.setProperty("--widthAfter", width_after);
    wrapper.style.setProperty("--speed", speed);
    wrapper.style.setProperty("--direction", direction);
    wrapper.style.setProperty("--start-time", start_time);
    wrapper.style.setProperty("--scale", scale);
    wrapper.style.setProperty("--z-position", z_position);

    wrapper.innerHTML = `
      <div class="vector">
        <div class="dot"></div>
      </div>
    `;

    return wrapper
  }

  connectedCallback() {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    const particleCount = isMobile ? 12 : 30;

    const container = document.createElement("div");
    container.className = "particle";

    for (let i = 0; i < particleCount; i++) {
      const dot = this.generateDot();
      container.appendChild(dot);
    }

    this.appendChild(container);
  }
}

customElements.define("particle-system", ParticleSystem);
